import axios from 'axios'
import { API_IDENTITY } from '../../config/config.json'
import { decryptStorage } from 'utils/utils';
export async function validateIdentityGeneralApi(data) {

  const headers = { Authorization: `Bearer ${decryptStorage(localStorage.getItem("token"))}` };

  return await axios.post(`${API_IDENTITY}/identity-general`, data, { headers }).then(async res => {
    if (!res.data.data.error) {
      return { data: res.data.data, status: 'success' }
    } else throw ({ message: res.data.data.error, status: 'error' })
  }).catch(err => {
    return { data: { message: err.message }, status: 'error' }
  })
}

export async function validateAniApi(data) {

  const headers = { Authorization: `Bearer ${decryptStorage(localStorage.getItem("token"))}` };
  let dataSend = {
    "documentNumber": data.documentNumber,
    "externalRequestId": data.externalRequestId
  }

  return await axios.post(`${API_IDENTITY}/ani`, dataSend, { headers }).then(async res => {
    if (!res.data.data.error) {
      return { data: res.data.data, status: 'success' }
    } else throw ({ message: res.data.data.error, status: 'error' })
  }).catch(err => {
    return { data: { message: err.message }, status: 'error' }
  })
}

export async function validateMuiscaApi(data) {

  const headers = { Authorization: `Bearer ${decryptStorage(localStorage.getItem("token"))}` };
  let dataSend = {
    "documentNumber": data.documentNumber,
    "externalRequestId": data.externalRequestId
  }

  return await axios.post(`${API_IDENTITY}/muisca`, dataSend, { headers }).then(async res => {
    if (!res.data.data.error) {
      return { data: res.data.data, status: 'success' }
    } else throw ({ message: res.data.data.error, status: 'error' })
  }).catch(err => {
    return { data: { message: err.message }, status: 'error' }
  })
}

export async function consultStatusCFApi(data) {

  const headers = { Authorization: `Bearer ${decryptStorage(localStorage.getItem("token"))}` };
  let dataSend = {
    "documentNumber": data.documentNumber,
    "externalRequestId": data.externalRequestId
  }

  return await axios.post(`${API_IDENTITY}/consult-status-confronta`, dataSend, { headers }).then(async res => {
    if (!res.data.data.error) {
      return { data: res.data.data, status: 'success' }
    } else throw ({ message: res.data.data.error, status: 'error' })
  }).catch(err => {
    return { data: { message: err.message }, status: 'error' }
  })
}

export async function getQuestionnaireCFApi(data) {

  const headers = { Authorization: `Bearer ${decryptStorage(localStorage.getItem("token"))}` };
  let dataSend = {
    "documentNumber": data.documentNumber,
    "externalRequestId": data.externalRequestId.toString(),
    "serviceType": "obtenerCuestionario",
    "documentType": data.documentType
  }
  return await axios.post(`${API_IDENTITY}/confronta`, dataSend, { headers }).then(async res => {

    if (!res.data.data.error) {
      return { data: res.data.data, status: 'success' }
    } else throw ({ message: res.data.data.error, status: 'error' })
  }).catch(err => {
    if (err.response && err.response.data) {
      return { data: { message: err.response.data.statusDescription }, status: 'error' }
    }
    else if (err.message && err.message.message) {
      return { data: { message: err.message.message }, status: 'error' }
    }
    return { data: { message: err.message }, status: 'error' }
  })
}


export async function evaluateQuestionnaireCFApi(data) {

  const headers = { Authorization: `Bearer ${decryptStorage(localStorage.getItem("token"))}` };

  return await axios.post(`${API_IDENTITY}/confronta`, data, { headers }).then(async res => {
    if (!res.data.data.error) {
      return { data: res.data.data, status: 'success' }
    } else throw ({ message: res.data.data.error, status: 'error' })
  }).catch(err => {
    return { data: { message: err.message }, status: 'error' }
  })
}

